import { render, staticRenderFns } from "./SelectIfClaimProgram.vue?vue&type=template&id=74ab6d28&scoped=true"
import script from "./SelectIfClaimProgram.vue?vue&type=script&lang=js"
export * from "./SelectIfClaimProgram.vue?vue&type=script&lang=js"
import style0 from "./SelectIfClaimProgram.vue?vue&type=style&index=0&id=74ab6d28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ab6d28",
  null
  
)

export default component.exports